import React, { useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Button,
  Divider,
  Select,
  Collapse,
  Row,
  Col,
  Form,
  message,
  Tabs,
  Spin,
  Checkbox
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import {
  INVENTORY_REPORT,
  OTHERREPORTS,
  PAYMENT_REPORT,
  PRODUCT_SCREEN,
  SALES_REPORT,
  TAX_REPORT
} from '../../../constants/Pages'
import SpecifiedDateRange from '../../../components/Reporting/SpecifiedDateRange'
import FormatResultFilter from '../../../components/Reporting/FormatResultFilter'
import ExportReport from '../../../components/Reporting/ExportReport'
import { withRouter } from 'react-router-dom'
import ComparisonDateSelectFilter from '../../../components/Reporting/ComparisonDateSelectFilter'
import InventoryReportsTab1Pic from '../../../assets/images/inventory-reports-summary.png'
import InventoryReportsTab2Pic from '../../../assets/images/inventory-reports-replenishment.png'
import InventoryReportsTab3Pic from '../../../assets/images/inventory-reports-performance.png'
import {
  loadCalculateComparison,
  loadSpecifiedDateRangeData,
  loadComparisonDateData
} from '../../../appRedux/actions/Reports'

import {
  checkRightspermissions,
  formatDigits,
  isEmptyObject,
  parseFloatCustom,
  StringIsNullOrEmpty,
  verifyPkgFeature
} from '../../../appRedux/actions'
import moment from 'moment'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { max } from 'lodash'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const Panel = Collapse.Panel
const TabPane = Tabs.TabPane
const CheckboxGroup = Checkbox.Group

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const DynamicReportsListing = ({ location, match }) => {
  const [form] = Form.useForm()
  const reportType = match.url.split('/')[3] //salesreports , Inventory Reports etc
  //Here we send api to
  const history = useHistory()
  const dispatch = useDispatch()
  const tableRef = useRef(null)

  const getReduxSpecifiedDateRangeData = useSelector(
    ({ Reports }) => Reports.specifiedDateRangeData
  )
  const getReduxComparisonDateData = useSelector(
    ({ Reports }) => Reports.comparisonDateData
  )
  const getReduxCalculated = useSelector(
    ({ Reports }) => Reports.getCalculatedComparison
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  const [isLoading, setIsLoading] = React.useState(true)
  const [pagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10
  })

  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencyName: '',
    currencySymbol: ''
  })
  // const [getDefaultDecimalPlaces, setDefaultDecimalPlace] = React.useState(2); //api me isko db sy update rakhna hy
  const [getIsFilterLoading, setIsFilterLoading] = React.useState(true)
  const [getReportsData, setReportsData] = React.useState([])
  const [getReportsSearchFilterData, setReportsSearchFilterData] =
    React.useState([])
  const [getReportFiltersInitialValues, setReportFiltersInitialValues] =
    React.useState({})
  const [getChildReportsData, setChildReportsData] = React.useState([])
  const [getIsProductPopoverVisible, setIsProductPopoverVisible] =
    React.useState(false)
  const [getTopHeader, setTopHeader] = React.useState([])
  const [getLastHeader, setLastHeader] = React.useState([])
  const [getRespData, setRespData] = React.useState([])
  const [getFooter, setFooter] = React.useState([])
  const [getSummaryData, setSummaryData] = React.useState([])
  const [getReqData, setReqData] = React.useState([])
  const [getFixedData, setFixedData] = React.useState([])
  const [getReqCompareMeasureData, setReqCompareMeasureData] = React.useState(
    []
  )
  const [getSummaryIndex, setSummaryIndex] = React.useState(-1)
  const [getTopFirstSpan, setTopFirstSpan] = React.useState(-1)
  const [getTopLastSpan, setTopLastSpan] = React.useState(-1)
  const [getFooterFirstSpan, setFooterFirstSpan] = React.useState(-1)
  const [getFooterLastSpan, setFooterLastSpan] = React.useState(-1)
  const [getTableLoader, setTableLoader] = React.useState(false)
  const [getReportMeasure, setReportMeasure] = React.useState('')
  const [isFirstTime, setIsFirstTime] = React.useState(false)
  const [getReportDataSymbol, setReportDataSymbol] = React.useState([])
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getActiveTab, setActiveTab] = useState(0)
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  const [pkgFeatureID, setPackageFeatureID] = useState(
    PkgFeatures.ReportingAndAnalytics
  )
  let RequestValues = []
  let RequestHeadersLength = ''
  let totalDataColumnCountValue = 1
  let totalPeriodColumnCountValue = 1
  let previousID = '' //This is used to hide product name, brand name , if same products multiple times . End Result Shows It a group of product;

  //#region  for use Selector

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getReduxExportReportType = useSelector(
    ({ Reports }) => Reports.exportReportType
  )
  //#endregion use Selector Region

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      // It's dynamic coming from DB
      // if (!checkIsWeb().exist) {
      //   postDataToApp(PostAppTypes.PAGE_HEADER, 'report.dynamic.report')
      // }
      const urlInfo = window.location.pathname
      const feature =
        urlInfo && urlInfo.toLowerCase().includes('inventoryreports')
          ? PkgFeatures.AdvancedInventoryReports
          : PkgFeatures.ReportingAndAnalytics
      setPackageFeatureID(feature)
      if (!verifyPkgFeature(feature)) {
        setIsFeatureAllowed(false)
      }

      let body = {
        ReportName: reportType
      }
      let pageID = '000'
      if (urlInfo && urlInfo.toLowerCase().includes('salesreports')) {
        pageID = SALES_REPORT
      } else if (
        urlInfo &&
        urlInfo.toLowerCase().includes('inventoryreports')
      ) {
        pageID = INVENTORY_REPORT
      } else if (urlInfo && urlInfo.toLowerCase().includes('paymentreports')) {
        pageID = PAYMENT_REPORT
      } else if (urlInfo && urlInfo.toLowerCase().includes('taxreports')) {
        pageID = TAX_REPORT
      } else if (urlInfo && urlInfo.toLowerCase().includes('otherreports')) {
        pageID = OTHERREPORTS
      }
      dispatch(setCommonConfigs(pageID))

      const url = checkUrlData(feature)
      const isFromUrl = url ? url : false
      getDynamicReportsData(body, isFromUrl, feature)
      setIsFirstTime(!isFromUrl ? true : false)
    }

    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    //salis
    if (
      mounted &&
      !isEmptyObject(getReduxSpecifiedDateRangeData) &&
      !isEmptyObject(getReportFiltersInitialValues) &&
      isFirstTime
    ) {
      setIsFirstTime(false)
      onFinish(false, getReportFiltersInitialValues)
      // console.log(
      //   "getReportFiltersInitialValues",
      //   getReportFiltersInitialValues
      // );
    }

    return () => (mounted = false)
  }, [getReduxSpecifiedDateRangeData, getReportFiltersInitialValues])

  //for common data -> store currency
  React.useEffect(() => {
    const commonData = getReduxCommonSetting
    if (
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.currencyData
    ) {
      let currencyData = commonData.storeCommonConfigs.storeConfig.currencyData
      // setCurrSymbol(currencyData.currencySymbol);
      // setShortCurr(currencyData.currencyCode);
      setCurrData(currencyData)
    }

    // rights && permissions
    if (commonData && commonData.storeCommonConfigs) {
      const rpData = checkRightspermissions(commonData)
      if (rpData && !isEmptyObject(rpData)) {
        setupRightsPermissions(rpData)
        setAccessLoading(false)
      } else {
        toInitialState()
        setAccessLoading(false)
      }
    }
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let exportReportObj = getReduxExportReportType
    // console.log(exportReportObj);
  }, [getReduxExportReportType])

  function setupRightsPermissions (rpData) {
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
  }

  function toInitialState () {
    setIsAllowRead(false)
  }

  async function getDynamicReportsData (body, isFromUrl, featureID) {
    setIsFilterLoading(true)
    const getDynamicReportsDataByID = ds.getDynamicReportsDataService(
      body,
      featureID
    )
    await getDynamicReportsDataByID
      .then(response => {
        setIsFilterLoading(false)
        if (response) {
          if (response.reports.length > 0) {
            let reportObj = response.reports
            let reportsSearchFilterData =
              response.reportSearchFilters &&
              response.reportSearchFilters.length > 0
                ? response.reportSearchFilters
                : []
            // console.log("report Obj", reportObj);
            if (
              reportObj.length > 1 &&
              reportObj[0].isParent == 1 &&
              reportObj[0].isChild == 0
            ) {
              let childReportsData = response.reports.filter(
                x => x.parentReportID != 0
              )
              setReportsData(reportObj)
              setChildReportsData(childReportsData)
              setReportsSearchFilterData([])
              let tempBody = {
                ReportName: reportObj[1].name
              }
              getDynamicReportsData(tempBody, isFromUrl, featureID)
            } else if (
              reportObj.length > 0 &&
              reportObj[0].isParent == 0 &&
              reportObj[0].isChild == 1
            ) {
              setReportsSearchFilterData(reportsSearchFilterData)

              const reprtMeasure =
                reportsSearchFilterData && reportsSearchFilterData.length > 0
                  ? reportsSearchFilterData.filter(
                      a =>
                        a.displayName ==
                        'reporting.dynamicreports.reportmeasure'
                    )
                  : []
              if (reprtMeasure && reprtMeasure.length > 0) {
                const filterData = reprtMeasure[0].filterData
                  ? reprtMeasure[0].filterData
                  : {}
                const name = filterData.displayName
                  ? filterData.displayName
                  : ''
              }
            } else if (
              reportObj.length > 0 &&
              reportObj[0].isParent == 0 &&
              reportObj[0].isChild == 0
            ) {
              setReportsData(reportObj)
              setChildReportsData([])
              setReportsSearchFilterData(reportsSearchFilterData)
              // console.log("Search Filter Data", reportsSearchFilterData);
              const reprtMeasure =
                reportsSearchFilterData && reportsSearchFilterData.length > 0
                  ? reportsSearchFilterData.filter(
                      a =>
                        a.displayName ==
                        'reporting.dynamicreports.reportmeasure'
                    )
                  : []
              if (reprtMeasure && reprtMeasure.length > 0) {
                const filterData = reprtMeasure[0].filtersData
                  ? reprtMeasure[0].filtersData
                  : {}
                const name =
                  filterData && filterData.length > 0
                    ? filterData[0].displayName
                    : ''
              }
            }

            if (reportObj.length > 0) {
              if (!checkIsWeb().exist) {
                postDataToApp(PostAppTypes.PAGE_HEADER, reportObj[0].title)
              }
            }
          }
          if (response.reportSearchFilters.length > 0) {
            //Isk db level pr le kr jana hy ,,after discussion

            let reportsData = response.reports
            let reportInitalValue = { ReportType: '1', ReportMeasure: '1' }
            let reportName =
              reportsData && reportsData[0].name != undefined
                ? reportsData[0].name
                : 'SalesReports'
            if (reportName == 'SalesReports') {
              reportInitalValue = {
                ReportType: '33',
                ReportMeasure: '3'
              }
            }

            if (response.reports && response.reports.length > 0) {
              if (response.reports[0].name == 'InventoryReportsSummary') {
                reportInitalValue = {
                  ReportType: '41',
                  ReportMeasure: '52',
                  Outlet: '0'
                }
              }
              if (response.reports[0].name == 'InventoryReportsReplishment') {
                reportInitalValue = {
                  ReportType: '41',
                  ReportMeasure: '52',
                  Outlet: '0'
                }
              }
              if (response.reports[0].name == 'InventoryReportsPerformance') {
                reportInitalValue = {
                  ReportType: '41',
                  ReportMeasure: '52',
                  Outlet: '0'
                }
              }
            }
            if (reportName == 'PaymentReports') {
              reportInitalValue = {
                ReportType: '49',
                ReportMeasure: '55'
              }
            }
            if (reportName == 'TaxReports') {
              reportInitalValue = {
                ReportType: '50',
                ReportMeasure: '0'
              }
            }
            if (reportName == 'OtherReports') {
              reportInitalValue = {
                ReportType: '60',
                ReportMeasure: '0',
                Outlet: '0'
              }
            }

            reportInitalValue = isFromUrl ? isFromUrl : reportInitalValue
            setReportFiltersInitialValues(reportInitalValue)
            form.setFieldsValue({
              ReportMeasure: reportInitalValue.ReportMeasure,
              ReportType: reportInitalValue.ReportType
            })
          }
        }
      })
      .catch(e => {
        setIsFilterLoading(false)
        // message.error("Something Went Wrong...");
      })
  }

  async function getReportsDataService (body, featureID) {
    setTableLoader(true)
    const getReports = ds.getReportsBIService(
      body,
      BEHAVIOUR_TYPE.GET,
      featureID
    )
    await getReports
      .then(res => {
        setTableLoader(false)
        if (res) {
          const data = res.data.data
          const reqData = res.data.requestedMeasureData
          const fixedData = res.data.fixedMeasuresData
          const requestedCompareMeasureData =
            res.data.requestedCompareMeasureData
          const top = res.data.topHeaderRow
          const last = res.data.lastHeaderRow
          const footer = res.data.footerRow
          const summary = res.data.summaryData
          const summaryIndex = res.data.summaryColumnIdx
          totalDataColumnCountValue = res.data.totalDataColumnCount
          totalPeriodColumnCountValue = res.data.totalPeriodColumnCount
          let Topjson
          let footJson

          if (top && top.length > 0) {
            Topjson = JSON.parse(top)
            setTopHeader(Topjson)
            const top1 = Topjson[0].Index ? Topjson[0].Index : 1
            const firstSpan = top1 - 1
            setTopFirstSpan(firstSpan)
          } else {
            setTopHeader([])
            setTopFirstSpan(-1)
          }

          if (footer) {
            footJson = JSON.parse(footer)
            // setFooter(footJson);
            setFooter(footJson)
            const firstIndex = footJson[0].Index - 1
            setFooterFirstSpan(firstIndex)
          } else {
            setFooter([])
            setFooterFirstSpan(-1)
          }

          if (last && last.length > 0) {
            const lastJson = JSON.parse(last)

            const lastJsonHeader = lastJson.map(x => {
              return {
                Year: x.Year,
                Index: x.Index,
                Value: x.Value.split('(')[0],
                Symbol:
                  x.Value != undefined && x.Value.includes('(')
                    ? x.Value.split('(')[1].replace(')', '')
                    : ''
              }
            })
            setLastHeader(lastJsonHeader)
            // console.log(lastJsonHeader);
            // setReportDataSymbol(symbolArray);
            const topKey =
              Topjson && Topjson.length > 0 ? Topjson.length - 1 : -1
            const lastKey = lastJson && lastJson.length - 1
            if (topKey && topKey != -1) {
              const topLast = Topjson[topKey].Index
              const lastFinal = lastJson[lastKey].Index - topLast
              setTopLastSpan(lastFinal)
            } else {
              setTopLastSpan(-1)
            }

            //footer last span
            const footerKey =
              footJson && footJson.length > 0 ? footJson.length - 1 : -1
            if (footerKey && footerKey != -1) {
              const footerLast = footJson[footerKey].Index
              const lastFinalFooter = lastJson[lastKey].Index - footerLast
              setFooterLastSpan(lastFinalFooter)
            } else {
              setFooterLastSpan(-1)
            }
          } else {
            setTopLastSpan(-1)
            setFooterLastSpan(-1)
            setLastHeader([])
          }

          if (data) {
            const json = JSON.parse(data)
            // setRespData(json);

            setRespData(json)
          } else {
            setRespData([])
          }

          if (reqData) {
            const reqJson = JSON.parse(reqData)
            setReqData(reqJson)
          } else {
            setReqData([])
          }

          if (requestedCompareMeasureData) {
            const reqCompareJson = JSON.parse(requestedCompareMeasureData)
            const aligned = Object.keys(reqCompareJson).map(
              err => reqCompareJson[err]
            )
            setReqCompareMeasureData(reqCompareJson)
          } else {
            setReqCompareMeasureData([])
          }

          if (fixedData) {
            const fixedJson = JSON.parse(fixedData)
            const aligned = Object.keys(fixedJson).map(err => fixedJson[err])
            setFixedData(fixedJson)
          } else {
            setFixedData([])
          }

          if (summary) {
            const summJson = JSON.parse(summary)
            // setSummaryData(summJson);
            setSummaryData(summJson)
          } else {
            setSummaryData([])
          }

          if (summaryIndex == 0 || summaryIndex > 0) {
            setSummaryIndex(summaryIndex)
          } else {
            setSummaryIndex(-1)
          }
        }
      })
      .catch(e => {
        setTableLoader(false)
        setTopHeader([])
        setLastHeader([])
        setRespData([])
        setFooter([])
        setSummaryData([])
        setReqData([])
        setFixedData([])
        setSummaryIndex(-1)
        setTopFirstSpan(-1)
        setTopLastSpan(-1)
        setFooterFirstSpan(-1)
        setFooterLastSpan(-1)
        message.error('')
        message.error('Something Went Wrong...')
      })
  }

  // async function postSaveExcelCall (body) {
  //   setIsFilterLoading(true)
  //   const req = ds.postSaveExcelService(body)
  //   await req
  //     .then(response => {
  //       debugger
  //       setIsFilterLoading(false)
  //       if (response) {
  //       }
  //     })
  //     .catch(e => {
  //       debugger
  //       setIsFilterLoading(false)
  //       // message.error("Something Went Wrong...");
  //     })
  // }

  async function postExport_B_64_Call (body, featureID) {
    setIsFilterLoading(true)

    const req = ds.postExport_B_Service(body, featureID)
    await req
      .then(response => {
        setIsFilterLoading(false)

        if (response) {
          postDataToApp(PostAppTypes.EXCEL_B_64, response)
        }
      })
      .catch(e => {
        setIsFilterLoading(false)
        // message.error("Something Went Wrong...");
      })
  }

  function checkUrlData (feature) {
    let res = false
    //salis

    const params = new URLSearchParams(location.search)
    const queryParam = params.get('definition')
    let jsonObj = JSON.parse(queryParam)
    if (jsonObj && !isEmptyObject(jsonObj)) {
      const measure = jsonObj.MeasureId ? jsonObj.MeasureId : '0'
      const reprt = jsonObj.ReportTypeId ? jsonObj.ReportTypeId : '0'
      const isComparison = jsonObj.IsComparision ? jsonObj.IsComparision : 0
      res = {
        ReportMeasure: `${measure}`,
        ReportType: `${reprt}`
      }
      const getSpecDate = localStorage.getItem('specDate')
        ? JSON.parse(localStorage.getItem('specDate'))
        : false
      const getCompDate = localStorage.getItem('compDate')
        ? JSON.parse(localStorage.getItem('compDate'))
        : false
      if (getSpecDate) {
        dispatch(loadSpecifiedDateRangeData(getSpecDate))
      }
      if (getCompDate) {
        dispatch(loadCalculateComparison(getCompDate))
      }
      dispatch(loadComparisonDateData(isComparison))
      getReportsDataService(jsonObj, feature)
    }
    return res
  }

  const onFinish = (value, fromOther) => {
    let validate = false
    let reportID = 0
    let periodID = 0
    let dateFrom = ''
    let dateTo = ''
    let compFrom = ''
    let compTo = ''
    let isPayOrSale = false
    let isCompare = 0
    let inventoryTypeName = ''
    if (fromOther && fromOther.inventoryType) {
      inventoryTypeName = fromOther.inventoryType
    } else {
      inventoryTypeName = GetInventoryTypeName(getActiveTab)
    }

    const dateValues = getReduxSpecifiedDateRangeData.IsSpecificPeriod
      ? getReduxSpecifiedDateRangeData.SpecificPeriodDates
        ? getReduxSpecifiedDateRangeData.SpecificPeriodDates
        : false
      : getReduxSpecifiedDateRangeData.SpecificDatesRange
      ? getReduxSpecifiedDateRangeData.SpecificDatesRange
      : false
    const repMeasure =
      value && value.ReportMeasure
        ? value.ReportMeasure
        : fromOther && fromOther.ReportMeasure
        ? fromOther.ReportMeasure
        : 0
    const repType =
      value && value.ReportType
        ? value.ReportType
        : fromOther && fromOther.ReportType
        ? fromOther.ReportType
        : 0
    const formatRadio = value && value.formatRadio ? value.formatRadio : ''
    const reprtName = reportType ? reportType.toLowerCase() : ''
    if (reprtName != '' && dateValues) {
      reportID = reprtName.includes('salesreports')
        ? 1
        : reprtName.includes('inventoryreports')
        ? 2
        : reprtName.includes('paymentreports')
        ? 3
        : reprtName.includes('taxreports')
        ? 4
        : reprtName.includes('otherreports')
        ? 5
        : 0
      isPayOrSale = reportID == 1 || reportID == 3
      dateFrom = dateValues.FromDate ? dateValues.FromDate : ''
      dateTo = dateValues.ToDate ? dateValues.ToDate : ''
      if (!dateTo) {
        dateTo = dateFrom
      }
      if (isPayOrSale) {
        const period = dateValues.Period ? dateValues.Period.toLowerCase() : ''
        if (period != '') {
          periodID = checkPeriod(period)
        } else {
          periodID = 29 //Date
        }
      }
      if (reportID > 0 && dateFrom != '' && dateTo != '' && repType) {
        if (formatRadio != '') {
          periodID = checkPeriod(formatRadio)
            ? checkPeriod(formatRadio)
            : periodID
        }
        const isHour = periodID == 31 ? true : false
        const resultDate = checkIfDateMoment(dateFrom, dateTo, isHour)
        dateFrom = resultDate.from
        dateTo = resultDate.to

        if (isPayOrSale) {
          if (!isNaN(getReduxComparisonDateData)) {
            isCompare = getReduxComparisonDateData
          }

          //  //old
          //   const compareData = getReduxComparisonDateData;

          //   if (!isEmptyObject(compareData)) {

          //     if (compareData.ComparisonValue) {
          //       isCompare = 1;
          //       compFrom = compareData.FromDate;
          //       compTo = compareData.ToDate;
          //     }
          //   }
        }
        validate = true
      }
    }
    if (validate) {
      let reqBody = {}

      if (reportID == 2) {
        reqBody = {
          ReportId: reportID,
          ReportTypeId: repType ? parseInt(repType) : 0,
          MeasureId: repMeasure ? parseInt(repMeasure) : 0,
          DateTimeFrom: dateFrom,
          DateTimeTo: dateTo,
          PeriodId: periodID,
          IsComparision: isCompare,
          ComparisionFrom: compFrom,
          ComparisionTo: compTo,
          Outlet: value.Outlet == '0' ? 'ALL' : value.Outlet,
          inventoryType: inventoryTypeName
        }
      } else if (reportID == 5) {
        reqBody = {
          ReportId: reportID,
          ReportTypeId: repType ? parseInt(repType) : 0,
          MeasureId: repMeasure ? parseInt(repMeasure) : 0,
          DateTimeFrom: dateFrom,
          DateTimeTo: dateTo,
          PeriodId: periodID,
          IsComparision: isCompare,
          ComparisionFrom: compFrom,
          ComparisionTo: compTo,
          Outlet: value.Outlet == '0' ? 'ALL' : value.Outlet
        }
      } else {
        reqBody = {
          ReportId: reportID,
          ReportTypeId: repType ? parseInt(repType) : 0,
          MeasureId: repMeasure ? parseInt(repMeasure) : 0,
          DateTimeFrom: dateFrom,
          DateTimeTo: dateTo,
          PeriodId: periodID,
          IsComparision: isCompare,
          ComparisionFrom: compFrom,
          ComparisionTo: compTo
        }
      }
      //salis
      getReportsDataService(reqBody, pkgFeatureID)
      //salis
      setQueryString(reqBody)
    }
  }

  function setQueryString (reqBody) {
    //salis
    let queryString = 'definition=' + JSON.stringify(reqBody)
    const specDate = getReduxSpecifiedDateRangeData
      ? JSON.stringify(getReduxSpecifiedDateRangeData)
      : false
    const compDate = getReduxCalculated
      ? JSON.stringify(getReduxCalculated)
      : false
    const searchFilter = getReportsSearchFilterData
      ? JSON.stringify(getReportsSearchFilterData)
      : false
    if (specDate) {
      localStorage.setItem('specDate', specDate)
    } else {
      localStorage.removeItem('specDate')
    }
    if (compDate) {
      localStorage.setItem('compDate', compDate)
    } else {
      localStorage.removeItem('compDate')
    }
    if (searchFilter) {
      localStorage.setItem('search', searchFilter)
    } else {
      localStorage.removeItem('search')
    }
    history.push(`${location.pathname}?${queryString}`)
  }

  function checkPeriod (period) {
    let result = period.includes('month')
      ? 26
      : period.includes('year')
      ? 27
      : period.includes('weekday')
      ? 28
      : period.includes('date')
      ? 29
      : period.includes('quarter')
      ? 30
      : period.includes('time')
      ? 31
      : period.includes('firstofweek')
      ? 32
      : 32
    return result
  }

  function checkIfDateMoment (from, to, isHour) {
    let returnValue = {
      from: from,
      to: to
    }
    if (moment.isMoment(from) || moment.isMoment(to)) {
      if (moment.isMoment(from)) {
        const fromDate = isHour
          ? moment(from, 'YYYY-MM-DD HH:mm:SS').format('yyyy-MM-DDTHH:mm:ss')
          : moment(from, 'YYYY-MM-DD').format('YYYY-MM-DD')
        returnValue.from = fromDate
      }
      if (moment.isMoment(to)) {
        const toDate = isHour
          ? moment(to, 'YYYY-MM-DD HH:mm:SS').format('yyyy-MM-DDTHH:mm:ss')
          : moment(to, 'YYYY-MM-DD').format('YYYY-MM-DD')
        returnValue.to = toDate
      }
    }
    return returnValue
  }
  function IsDate (date) {
    let obj = date
    let isValid = false
    if (obj.includes('-')) {
      obj = obj.split('-').length
      if (obj == 3) {
        isValid = true
      }
    }
    var date1 = isValid ? moment(date).isValid() : false
    return date1
  }

  function getDecryptID (id) {
    return id ? id.substring(0, id.indexOf('&')) : ''
  }
  function GetInventoryTypeName (key) {
    let inventoryTypeName = 'Summary'
    if (key == 0) {
      inventoryTypeName = 'Summary'
    } else if (key == 1) {
      inventoryTypeName = 'Replenishment'
    } else if (key == 2) {
      inventoryTypeName = 'Performance'
    }
    return inventoryTypeName
  }
  function onTabChange (key) {
    setActiveTab(key)
    let inventoryTypeName = GetInventoryTypeName(key)
    let body = {
      ReportName: getChildReportsData[key].name
    }
    getDynamicReportsData(pkgFeatureID)
    let jsonObj = getReportFiltersInitialValues
    jsonObj.inventoryType = inventoryTypeName
    onFinish(false, jsonObj)
  }

  const GetReportDynamicLink = (key, value) => {
    let reportType =
      key && key.Value != undefined
        ? key.Value.trim().replace(' ', '').toLowerCase()
        : ''
    let id = value.includes('¬~¬')
      ? value.split('¬~¬')[0] != undefined &&
        !StringIsNullOrEmpty(value.split('¬~¬')[0])
        ? value.split('¬~¬')[0].trim() != '0&'
          ? value
              .split('¬~¬')[0]
              .trim()
              .concat('&_c1c3-444d-4ca7-8c52-9ac1853c44a6')
          : ''
        : ''
      : value
    let displayValue = value.includes('¬~¬')
      ? value.split('¬~¬')[1] != undefined
        ? value.split('¬~¬')[1].trim()
        : value.split('¬~¬')[0]
      : value
    let redirectURL = ''

    if (displayValue.includes('N/A')) {
      displayValue = `No ${key.Value}`
    }

    if (!StringIsNullOrEmpty(id)) {
      switch (reportType) {
        case 'summary':
          redirectURL = ''
          break
        case 'user':
          redirectURL = `/dashboard/setup/users/edit/${id}/1`
          break
        case 'outlet':
          redirectURL = '' // `/Dashboard/setup/outletsandregisters/editoutlet/${id}/1`;
          break
        case 'register':
          redirectURL = `/Dashboard/setup/outletsandregisters/editregister/${id}/1`
          break
        case 'customer':
          redirectURL = `/dashboard/customers/addcustomer/${id}`
          break
        case 'customergroup':
          redirectURL = `/dashboard/Customers/customergroup/${id}`
          break
        case 'promotion':
          redirectURL = `/Dashboard/products/promotions/edit/${id}`
          break
        case 'saleschannel':
          redirectURL = ``
          break
        case 'product':
          redirectURL = `/Dashboard/products/main/edit/${id}`

          break
        case 'sku':
          redirectURL = `/Dashboard/products/main/edit/${id}`
          break
        case 'skucode':
          redirectURL = `/Dashboard/products/main/edit/${id}`
          break
        case 'brand':
          // redirectURL = `/dashboard/products/Brands/${id}`;
          redirectURL = `/dashboard/products/main/listing/brandid/${id}`
          break
        case 'supplier':
          redirectURL = `/Dashboard/products/supplier/edit/${getDecryptID(id)}`
          break
        case 'producttype':
          // redirectURL = `/dashboard/products/producttypes/${id}`;
          redirectURL = `/dashboard/products/main/listing/typeid/${id}`
          break
        case 'tag':
          // redirectURL = `/dashboard/products/producttags/${id}`;

          redirectURL = `/dashboard/products/main/listing/tagid/${id}`
          break
        case 'productvariant':
          redirectURL = `/Dashboard/products/main/edit/${id}`
          break
        case 'variantname':
          redirectURL = `/Dashboard/products/main/edit/${id}`
          break
        default:
          redirectURL = ''
          break
      }
    }

    return !StringIsNullOrEmpty(redirectURL) ? (
      <span
        className='dk-text-reporting '
        onClick={() => {
          history.push(redirectURL)
        }}
        style={{ fontWeight: '400' }}
      >
        <div dangerouslySetInnerHTML={{ __html: displayValue }}></div>
      </span>
    ) : (
      <span style={{ fontWeight: '400' }}>{displayValue}</span>
    )
  }

  function exportToExcel () {
    if (getRespData && getRespData.length > 0) {
      // var location = 'data:application/vnd.ms-excel;base64,'
      var excelTemplate =
        '<html> ' +
        '<head> ' +
        '<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/> ' +
        '</head> ' +
        '<body> ' +
        document.getElementById('table-conatainer').innerHTML +
        '</body> ' +
        '</html>'
      //  window.location.href = location + window.btoa(excelTemplate)
      postExport_B_64_Call({ htmlBody: excelTemplate }, pkgFeatureID)
    }
  }

  return getIsAllowRead && isFeatureAllowed ? (
    <div className='Content-wrapper SalesReport-pg'>
      <Spin
        tip={<IntlMessages id='common.resource.loading' />}
        spinning={getIsFilterLoading}
        size='large'
      >
        {checkIsWeb().exist &&
          getReportsData &&
          getReportsData != null &&
          getReportsData.length > 0 && (
            <Row>
              <Col md={24}>
                <h1 className=''>
                  <IntlMessages id={getReportsData[0].title} />
                </h1>
              </Col>
            </Row>
          )}

        {getChildReportsData &&
        getChildReportsData != undefined &&
        getChildReportsData.length > 0 ? (
          <Card className='tab-body-parent'>
            <Tabs
              defaultActiveKey={getActiveTab}
              size='large'
              onChange={onTabChange}
            >
              {getChildReportsData &&
                getChildReportsData
                  // .filter((x, index) => index == 0)
                  .map((childReportObj, index) => {
                    return (
                      <TabPane
                        tab={<IntlMessages id={childReportObj.title} />}
                        value={getDecryptID(childReportObj.reportID)}
                        key={index}
                      >
                        <Collapse>
                          <Panel
                            className='custom-promolist-help'
                            showArrow={true}
                            header={
                              <IntlMessages id={childReportObj.heading} />
                            }
                          >
                            <Row>
                              <div className='billing-main'>
                                <Col
                                  className='custom-promolist-helpdesc'
                                  md={12}
                                >
                                  <p>
                                    <IntlMessages
                                      id={childReportObj.description}
                                    />
                                  </p>
                                  <p>
                                    <IntlMessages
                                      id={childReportObj.description2}
                                    />
                                  </p>
                                </Col>

                                <Col span={12}>
                                  <img
                                    src={
                                      childReportObj.imageName ==
                                      'InventoryReportsTab1Pic'
                                        ? InventoryReportsTab1Pic
                                        : childReportObj.imageName ==
                                          'InventoryReportsTab2Pic'
                                        ? InventoryReportsTab2Pic
                                        : childReportObj.imageName ==
                                          'InventoryReportsTab3Pic'
                                        ? InventoryReportsTab3Pic
                                        : ''
                                    }
                                    alt=''
                                  />
                                </Col>
                              </div>
                            </Row>
                          </Panel>
                        </Collapse>
                      </TabPane>
                    )
                  })}
            </Tabs>
          </Card>
        ) : (
          ''
        )}

        <Card className='gx-card Filters-wrapper No-BoxShadow'>
          <Form
            {...formItemLayout}
            form={form}
            name={'SearchFormReport'}
            className='ant-advanced-search-form product-search-form Filters-Form TaxReport-Filters'
            layout='horizontal'
            onFinish={onFinish}
            initialValues={getReportFiltersInitialValues}
          >
            <Row>
              {getReportsSearchFilterData.map((searchFilerObj, index) => {
                return (
                  <>
                    {searchFilerObj.name === 'ReportType' && (
                      <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                          className='ant-form-item-label-custom Filters-Form'
                          name={searchFilerObj.name}
                          label={
                            <IntlMessages id={searchFilerObj.displayName} />
                          }
                        >
                          <Select
                            size='large'
                            showSearch={checkIsWeb().exist}
                            optionFilterProp='children'
                          >
                            {searchFilerObj &&
                              searchFilerObj.filtersData != undefined &&
                              searchFilerObj.filtersData.length > 0 &&
                              searchFilerObj.filtersData.map(
                                (filterDataObj, key) => {
                                  return (
                                    <Select.Option
                                      key={key}
                                      value={getDecryptID(filterDataObj.id)}
                                    >
                                      {filterDataObj.displayName}
                                    </Select.Option>
                                  )
                                }
                              )}
                          </Select>
                        </Form.Item>
                      </Col>
                    )}
                    {searchFilerObj.name === 'ReportMeasure' && (
                      <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                          className='ant-form-item-label-custom Filters-Form'
                          name={searchFilerObj.name}
                          label={
                            <IntlMessages id={searchFilerObj.displayName} />
                          }
                        >
                          <Select
                            size='large'
                            showSearch={checkIsWeb().exist}
                            optionFilterProp='children'
                          >
                            {searchFilerObj &&
                              searchFilerObj.filtersData != undefined &&
                              searchFilerObj.filtersData.length > 0 &&
                              searchFilerObj.filtersData.map(
                                (filterDataObj, key) => {
                                  return (
                                    <Select.Option
                                      key={key}
                                      value={getDecryptID(filterDataObj.id)}
                                    >
                                      {filterDataObj.displayName}
                                    </Select.Option>
                                  )
                                }
                              )}
                          </Select>
                        </Form.Item>
                      </Col>
                    )}
                    {searchFilerObj.name != undefined &&
                      searchFilerObj.name.split('_')[0] === 'DateRange' && (
                        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                          <SpecifiedDateRange tabs={searchFilerObj.name} />
                        </Col>
                      )}
                    {!getReduxSpecifiedDateRangeData ||
                    (getReduxSpecifiedDateRangeData &&
                      getReduxSpecifiedDateRangeData.SpecificPeriodDates &&
                      getReduxSpecifiedDateRangeData.SpecificPeriodDates
                        .Period &&
                      getReduxSpecifiedDateRangeData.SpecificPeriodDates
                        .Period != 'time' &&
                      getReduxSpecifiedDateRangeData.SpecificPeriodDates
                        .Period != 'year') ? (
                      <>
                        {searchFilerObj.name === 'Comparison' && (
                          <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                            <ComparisonDateSelectFilter />
                          </Col>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                )
              })}
              {getReportsData &&
              getReportsData[0] &&
              getReportsData[0].reportID ? (
                getDecryptID(getReportsData[0].reportID) == '3' ||
                getDecryptID(getReportsData[0].reportID) == '14' ? (
                  <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                    <Form.Item
                      className='ant-form-item-label-custom'
                      name={'Outlet'}
                      label={<IntlMessages id='sell.salehistory.out' />}
                    >
                      <Select
                        defaultValue={'0'}
                        showSearch={checkIsWeb().exist}
                        size='large'
                        optionFilterProp='children'
                      >
                        <Select.Option
                          Selected={form.getFieldsValue(
                            'Outlet' == '0' ? true : false
                          )}
                          key={'0'}
                          value={'0'}
                        >
                          {'All'}
                        </Select.Option>
                        {getReduxStoreOutlets &&
                          getReduxStoreOutlets.length > 0 &&
                          getReduxStoreOutlets.map((e, key) => {
                            return (
                              <Select.Option key={key} value={e.outlet}>
                                {e.outlet}
                              </Select.Option>
                            )
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )
              ) : (
                ''
              )}
            </Row>

            {getReduxSpecifiedDateRangeData &&
              getReduxSpecifiedDateRangeData.SpecificPeriodDates &&
              getReduxSpecifiedDateRangeData.SpecificPeriodDates.Period &&
              (getReduxSpecifiedDateRangeData.SpecificPeriodDates.Period ==
                'time' ||
                getReduxSpecifiedDateRangeData.SpecificPeriodDates.Period ==
                  'year') &&
              getReportsSearchFilterData.map((searchFilerObj, index) => {
                return (
                  <Row>
                    {searchFilerObj.name === 'Comparison' && (
                      <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                        <ComparisonDateSelectFilter />
                      </Col>
                    )}
                  </Row>
                )
              })}

            <Col lg={24} md={24} sm={24} xs={24}>
              <Button
                className='float-right'
                htmlType='submit'
                type='primary'
                size='large'
              >
                <IntlMessages id='reporting.productInventorymovements.search' />
              </Button>
            </Col>
          </Form>
        </Card>

        <div className='dk-flex dk-flex--justify-between top-space-10'>
          {getReportsData &&
          getReportsData[0] &&
          getReportsData[0].showColumnFormatResult ? (
            getReportsData[0].showColumnFormatResult == 1 ? (
              <Form
                form={form}
                name={'SearchForm'}
                className='ant-advanced-search-form product-search-form'
                layout='horizontal'
                onFinish={onFinish}
              >
                <FormatResultFilter isColumnFormat={true} />{' '}
              </Form>
            ) : getReportsData[0].showRowFormatResult == 1 ? (
              <FormatResultFilter isColumnFormat={false} />
            ) : (
              ''
            )
          ) : (
            ''
          )}
          {getRespData && getRespData.length > 0 && (
            <ExportReport tableRef={tableRef} app_export={exportToExcel} />
          )}
        </div>
      </Spin>

      <Spin
        tip={<IntlMessages id='common.resource.loading' />}
        spinning={getTableLoader}
        size='large'
      >
        <div
          style={{ marginBottom: 18, marginTop: 16 }}
          className='scrollmenu'
          id='table-conatainer'
        >
          <table
            className='datatable reporting-table'
            style={{ tableLayout: 'auto' }}
            ref={tableRef}
          >
            <thead className='custom-text-center'>
              {getTopHeader && getTopHeader.length > 0 && (
                <tr className='datatable-col-header-row'>
                  {getTopFirstSpan && getTopFirstSpan != -1 && (
                    <th
                      colspan={getTopFirstSpan}
                      className='ant-table-cell'
                    ></th>
                  )}
                  {getTopHeader.map((e, key) => {
                    const nextExist = getTopHeader[key + 1]
                    let colSpan = !nextExist ? 1 : nextExist.Index - e.Index
                    colSpan =
                      e.Value.toLocaleLowerCase() == 'total' &&
                      getLastHeader &&
                      getLastHeader.length > 1 &&
                      getLastHeader.filter(x =>
                        x.Value.toLowerCase().includes('comparison')
                      ).length > 0
                        ? colSpan + 1
                        : colSpan

                    return (
                      <th
                        key={key}
                        colspan={colSpan}
                        className={`${
                          e.Value && e.Value.toLowerCase() == 'total'
                            ? 'datatable-row-aggs-header ss'
                            : 'datatable-row-label-header-label--start ant-table-cell'
                        }`}
                      >
                        {e.Value}
                      </th>
                    )
                  })}
                  {getTopLastSpan && getTopLastSpan != -1 && (
                    <th
                      className='datatable-row-aggs-header-label--start datatable-row-aggs-header-label--end ant-table-cell'
                      colspan={getTopLastSpan}
                    ></th>
                  )}
                </tr>
              )}
              {getLastHeader && getLastHeader.length > 0 && (
                <tr className='datatable-col-labels-row reporting-label-row'>
                  {getLastHeader
                    .filter(a => !a.year)
                    .map((ee, kkey) => {
                      let lastHeadFirstSpanShow = true
                      const key = kkey - 1
                      if (key != -1) {
                        const prevEl = getLastHeader[key].Index
                        const check = ee.Index - prevEl
                        if (check > 1) {
                          lastHeadFirstSpanShow = false
                        }
                      }
                      if (lastHeadFirstSpanShow) {
                        return (
                          <th
                            key={kkey}
                            className='datatable-row-label-label datatable-row-label-label--last ant-table-cell dk-reporting-font-size-12 skk'
                          >
                            <div className='dk-flex dk--flex--justify-between dk-flex--align-center ant-table-cell'>
                              <span>
                                {false
                                  ? getReportMeasure
                                  : `${ee.Value ? ee.Value : ''}`}
                              </span>
                            </div>
                          </th>
                        )
                      }
                    })}
                  {getLastHeader
                    .filter(ac => ac.year)
                    .map((xx, ikey) => {
                      let classs = 'datatable-col-label ant-table-cell'
                      const firstClass =
                        'datatable-col-label datatable-cell--section-start ant-table-cell'
                      if (ikey == 0) {
                        classs = firstClass
                      } else {
                        const prevElement = getLastHeader.filter(ac => ac.year)[
                          ikey - 1
                        ]
                        if (prevElement.year != xx.year) {
                          classs = firstClass
                        }
                      }
                      return (
                        <th key={ikey} className={classs}>
                          {false
                            ? getReportMeasure
                            : `${xx.Value ? xx.Value : ''}`}
                        </th>
                      )
                    })}
                  {getLastHeader
                    .filter(a => !a.year)
                    .map((ff, jkey) => {
                      let lastHeadLastSpanShow = false
                      const key = jkey - 1
                      if (key != -1) {
                        const prevEl = getLastHeader[key].Index
                        const check = ff.Index - prevEl
                        if (check > 1) {
                          lastHeadLastSpanShow = true
                        }
                      }
                      if (lastHeadLastSpanShow) {
                        return (
                          <th
                            key={jkey}
                            className='dk-text-label datatable-row-aggs-label datatable-row-aggs-label--start datatable-row-aggs-label--sortable ant-table-cell'
                          >
                            <div className='datatable-row-aggs-label-link'>
                              <a>
                                {false
                                  ? getReportMeasure
                                  : `${ff.Value ? ff.Value : ''}`}
                              </a>
                            </div>
                          </th>
                        )
                      }
                    })}
                </tr>
              )}
            </thead>
            <tbody className='' style={{ fontSize: 13 }}>
              {getRespData && getRespData.length > 0 ? (
                getRespData.map((zz, pkey) => {
                  let reqValues = []
                  let fixedValues = []
                  let reqCompValues = []
                  const arr = Object.keys(zz).map(k => zz[k])
                  RequestHeadersLength = arr.length
                  return (
                    <tr key={pkey} className='datatable-row reporting-data-row'>
                      {arr.map((ss, fkey) => {
                        let displayValue = ''
                        let checkValue = ''
                        let symbol = ''
                        let isHideDisplayValue = false
                        const isSupplier = Object.keys(zz)
                          [fkey].toLowerCase()
                          .includes('suppliercode')

                        if (ss) {
                          if (fkey == 0) {
                            displayValue = GetReportDynamicLink(
                              getLastHeader[fkey],
                              ss
                            )

                            if (
                              ss &&
                              ss != 'Total' &&
                              !StringIsNullOrEmpty(previousID) &&
                              ss.split('&')[0] == previousID
                            ) {
                              isHideDisplayValue = true
                            }
                            previousID =
                              ss && ss.split('&')[0] ? ss.split('&')[0] : ''
                          } else {
                            if (ss.includes('¬~¬')) {
                              displayValue = GetReportDynamicLink(
                                getLastHeader[fkey],
                                ss
                              )
                            } else {
                              if (ss.includes('/') || isSupplier) {
                                displayValue = ss
                              } else if (
                                parseFloatCustom(ss).toFixed(
                                  getDefaultDecimalPlaces
                                ) != 'NaN'
                              ) {
                                IsDate(ss)
                                  ? (displayValue =
                                      moment(ss).format('Do MMMM, YYYY'))
                                  : (displayValue = formatDigits(
                                      ss,
                                      getDefaultDecimalPlaces
                                    ))
                              } else {
                                displayValue = ss
                              }
                            }
                          }
                        }
                        checkValue = fkey == 0 ? ss : 'x0x'
                        const req = getReqData
                        const fixed = getFixedData
                        const reqCompare = getReqCompareMeasureData
                        // for req body print
                        if (req && req.length > 0) {
                          const reqBody = req.map(ass => {
                            const fg = Object.keys(ass).map(er => ass[er])
                            return {
                              fg
                            }
                          })
                          if (reqBody && reqBody.length > 0) {
                            reqBody.map(op => {
                              if (op.fg && op.fg.length > 0) {
                                op.fg.map(vv => {
                                  if (vv === checkValue) {
                                    reqValues = op.fg
                                    return
                                  }
                                })
                              }
                            })
                            RequestValues = reqValues
                          }
                        }

                        if (reqCompare && reqCompare.length > 0) {
                          const reqCompareBody = reqCompare.map(vbv => {
                            const wwe = Object.keys(vbv).map(err => vbv[err])
                            return {
                              wwe
                            }
                          })
                          if (reqCompareBody && reqCompareBody.length > 0) {
                            reqCompareBody.map(opp => {
                              if (opp.wwe && opp.wwe.length > 0) {
                                opp.wwe.map(vxv => {
                                  if (vxv === checkValue) {
                                    reqCompValues = opp.wwe
                                    return
                                  }
                                })
                              }
                            })
                          }
                        }

                        // for fixed body print
                        if (fixed && fixed.length > 0) {
                          const fixedBody = fixed.map(vbv => {
                            const wwe = Object.keys(vbv).map(err => vbv[err])
                            return {
                              wwe
                            }
                          })
                          if (fixedBody && fixedBody.length > 0) {
                            fixedBody.map(opp => {
                              if (opp.wwe && opp.wwe.length > 0) {
                                opp.wwe.map(vxv => {
                                  if (vxv === checkValue) {
                                    fixedValues = opp.wwe
                                    return
                                  }
                                })
                              }
                            })
                          }
                        }

                        if (fkey != 0 && displayValue != '' && !IsDate(ss)) {
                          symbol =
                            getLastHeader[fkey] &&
                            getLastHeader[fkey].Symbol != undefined
                              ? getLastHeader[fkey].Symbol
                              : ''
                        }

                        return (
                          <td
                            key={fkey}
                            className={`arr datatable-row-aggs datatable-row-aggs--start datatable-cell--nullable ant-table-cell ${
                              fkey == 0 ||
                              Object.keys(displayValue).includes('$$typeof')
                                ? ''
                                : parseFloatCustom(displayValue) < 0
                                ? 'dk-text-red'
                                : ''
                            }`}
                          >
                            {isHideDisplayValue
                              ? ''
                              : fkey == 0 ||
                                Object.keys(displayValue).includes('$$typeof')
                              ? displayValue
                              : `${displayValue}${symbol}`}
                          </td>
                        )
                      })}

                      {reqValues &&
                        reqValues.length > 0 &&
                        reqValues.map((bb, mkey) => {
                          let displayValue = ''
                          let symbol = ''
                          if (bb) {
                            if (bb.includes('/')) {
                              displayValue = bb
                            } else if (
                              parseFloatCustom(bb).toFixed(
                                getDefaultDecimalPlaces
                              ) != 'NaN'
                            ) {
                              IsDate(bb)
                                ? (displayValue =
                                    moment(bb).format('Do MMMM, YYYY'))
                                : (displayValue = formatDigits(
                                    bb,
                                    getDefaultDecimalPlaces
                                  ))
                            } else {
                              displayValue = bb
                            }
                            if (displayValue != '' && !IsDate(bb)) {
                              symbol =
                                getLastHeader[arr.length - 1 + mkey] &&
                                getLastHeader[arr.length - 1 + mkey].Symbol !=
                                  undefined
                                  ? getLastHeader[arr.length - 1 + mkey].Symbol
                                  : ''
                            }
                          }
                          return (
                            mkey != 0 && (
                              <td
                                key={mkey}
                                className={`reqValues datatable-row-aggs datatable-row-aggs--start datatable-cell--nullable ant-table-cell ${
                                  parseFloatCustom(displayValue) < 0
                                    ? 'dk-text-red'
                                    : ''
                                }`}
                              >
                                {displayValue} {symbol}
                              </td>
                            )
                          )
                        })}

                      {reqCompValues &&
                        reqCompValues.length > 0 &&
                        reqCompValues.map((bxb, mkkey) => {
                          let displayValue = ''
                          let symbol = ''
                          if (bxb) {
                            if (bxb.includes('/')) {
                              displayValue = bxb
                            } else if (
                              parseFloatCustom(bxb).toFixed(
                                getDefaultDecimalPlaces
                              ) != 'NaN'
                            ) {
                              IsDate(bxb)
                                ? (displayValue =
                                    moment(bxb).format('Do MMMM, YYYY'))
                                : (displayValue = formatDigits(
                                    bxb,
                                    getDefaultDecimalPlaces
                                  ))
                            } else {
                              displayValue = bxb
                            }
                            if (displayValue != '' && !IsDate(bxb)) {
                              symbol =
                                getLastHeader[
                                  arr.length - 1 + reqValues.length - 1 + mkkey
                                ] &&
                                getLastHeader[
                                  arr.length - 1 + reqValues.length - 1 + mkkey
                                ].Symbol != undefined
                                  ? getLastHeader[
                                      arr.length -
                                        1 +
                                        reqValues.length -
                                        1 +
                                        mkkey
                                    ].Symbol
                                  : ''
                            }
                          }
                          return (
                            mkkey != 0 && (
                              <td
                                key={mkkey}
                                className={`reqCompareValues datatable-row-aggs datatable-row-aggs--start datatable-cell--nullable ant-table-cell ${
                                  parseFloatCustom(displayValue) < 0
                                    ? 'dk-text-red'
                                    : ''
                                }`}
                              >
                                {displayValue} {symbol}
                              </td>
                            )
                          )
                        })}

                      {reqCompValues.length == 0 &&
                      getLastHeader &&
                      getLastHeader.length > 0 &&
                      getLastHeader.filter(x =>
                        x.Value.toLowerCase().includes('comparison')
                      ).length > 0 ? (
                        <td
                          key={0}
                          className={`reqCompareEmptyValues datatable-row-aggs datatable-row-aggs--start datatable-cell--nullable ant-table-cell 
                        }`}
                        >
                          -
                        </td>
                      ) : (
                        ''
                      )}

                      {fixedValues &&
                        fixedValues.length > 0 &&
                        fixedValues.map((bxb, mkkey) => {
                          let displayValue = ''
                          let symbol = ''
                          if (bxb) {
                            if (bxb.includes('/')) {
                              displayValue = bxb
                            } else if (
                              parseFloatCustom(bxb).toFixed(
                                getDefaultDecimalPlaces
                              ) != 'NaN'
                            ) {
                              IsDate(bxb)
                                ? (displayValue =
                                    moment(bxb).format('Do MMMM, YYYY'))
                                : (displayValue = formatDigits(
                                    bxb,
                                    getDefaultDecimalPlaces
                                  ))
                            } else {
                              displayValue = bxb
                            }
                            if (displayValue != '' && !IsDate(bxb)) {
                              symbol =
                                getLastHeader[
                                  arr.length - 1 + reqValues.length - 1 + mkkey
                                ] &&
                                getLastHeader[
                                  arr.length - 1 + reqValues.length - 1 + mkkey
                                ].Symbol != undefined
                                  ? getLastHeader[
                                      arr.length -
                                        1 +
                                        reqValues.length -
                                        1 +
                                        mkkey
                                    ].Symbol
                                  : ''
                            }
                          }
                          return (
                            mkkey != 0 && (
                              <td
                                key={mkkey}
                                className={`fixedValues datatable-row-aggs datatable-row-aggs--start datatable-cell--nullable ant-table-cell ${
                                  parseFloatCustom(displayValue) < 0
                                    ? 'dk-text-red'
                                    : ''
                                }`}
                              >
                                {displayValue} {symbol}
                              </td>
                            )
                          )
                        })}
                    </tr>
                  )
                })
              ) : (
                <tr className='datatable-row'>
                  <td
                    colspan={getLastHeader.length}
                    style={{ textAlign: 'center', height: 62 }}
                  >
                    <strong>Data is not present</strong>
                  </td>
                </tr>
              )}
              {getFooter && getFooter.length > 0 && (
                <tr
                  className='datatable-col-totals-row reporting-table-totals-row'
                  ng-show='!reportDatatable.canLoadMore || !reportDatatable.paginated'
                >
                  <th colspan={getFooterFirstSpan} className='ant-table-cell'>
                    Totals
                  </th>
                  {getFooter.map((as, qkey) => {
                    let classs =
                      'datatable-cell--nullable ant-table-cell datatable-cell--section-start'
                    let symbol = ''
                    const firstClass =
                      'datatable-cell--nullable datatable-cell--section-start ant-table-cell'
                    let displayValue = ''
                    if (as.Value) {
                      if (as.Value.includes('/')) {
                        displayValue = as.Value
                      } else if (
                        parseFloatCustom(as.Value).toFixed(
                          getDefaultDecimalPlaces
                        ) != 'NaN'
                      ) {
                        IsDate(as.Value)
                          ? (displayValue = moment(as.Value).format(
                              'Do MMMM, YYYY'
                            ))
                          : (displayValue = formatDigits(
                              as.Value,
                              getDefaultDecimalPlaces
                            ))
                      } else {
                        displayValue = as.Value
                      }
                    }
                    if (qkey == 0) {
                      classs = firstClass
                    }
                    if (displayValue != '' && !IsDate(as.Value)) {
                      symbol =
                        getLastHeader[as.Index - 1] &&
                        getLastHeader[as.Index - 1].Symbol != undefined
                          ? getLastHeader[as.Index - 1].Symbol
                          : ''
                    }
                    return (
                      <td
                        key={qkey}
                        className={`${classs} ${
                          parseFloatCustom(displayValue) < 0
                            ? 'dk-text-red'
                            : ''
                        }`}
                        style={{ fontSize: 13, whiteSpace: 'nowrap' }}
                      >
                        {displayValue} {symbol}
                      </td>
                    )
                  })}
                  {getFooterLastSpan > 0 && (
                    <td
                      colSpan={getFooterLastSpan}
                      className='datatable-cell--nullable ant-table-cell'
                    ></td>
                  )}
                </tr>
              )}
            </tbody>
            {getSummaryData && getSummaryData.length > 0 && (
              <tfoot ng-show='!reportDatatable.canLoadMore || !reportDatatable.paginated'>
                {getSummaryData.map((cv, lkey) => {
                  const array = Object.keys(cv).map(k => cv[k])
                  return (
                    <tr key={lkey} className='datatable-col-aggs-row '>
                      {array.map((ww, ykey) => {
                        let symbol = ''
                        if (ww && ww != null) {
                          //&& array.length - 1 == ykey
                          let arrayFindObj = array[0].includes('(')
                            ? array[0].split('(')[0].trim().toLowerCase()
                            : array[0].trim().toLowerCase()
                          let lastHeaderArray = getLastHeader.filter(
                            x => x.Value.trim().toLowerCase() === arrayFindObj
                          )
                          symbol =
                            lastHeaderArray.length >= 1
                              ? lastHeaderArray[0].Symbol
                              : ''
                        }
                        return ykey == 0 ? (
                          <th
                            colspan={getSummaryIndex - 1}
                            className='datatable-col-aggs-label ant-table-cell dk-reporting-font-size-12'
                          >
                            {ww ? ww : ''}
                          </th>
                        ) : (
                          <td
                            style={{
                              fontSize: 13,
                              textAlign: 'initial',
                              whiteSpace: 'nowrap'
                            }}
                            className={`datatable-col-aggs datatable-cell--nullable datatable-cell--section-start ant-table-cell ${
                              ww
                                ? parseFloatCustom(ww).toFixed(
                                    getDefaultDecimalPlaces
                                  ) < 0
                                  ? 'dk-text-red'
                                  : ''
                                : ''
                            }`}
                          >
                            {ww
                              ? parseFloatCustom(ww).toFixed(
                                  getDefaultDecimalPlaces
                                ) != 'NaN'
                                ? formatDigits(ww, getDefaultDecimalPlaces)
                                : ww
                              : ''}{' '}
                            {symbol} {'\u00a0'}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
              </tfoot>
            )}
          </table>
        </div>
      </Spin>
    </div>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default withRouter(DynamicReportsListing)
